import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLockBodyScroll } from "react-use";
import * as Ham from "../style/hamburger-style";

export const HamburgerMenu: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useLockBodyScroll(menuOpen);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = (path: string, hash?: string) => {
    setMenuOpen(false);

    if (hash && window.location.pathname === path) {
      const section = document.getElementById(hash);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(path + (hash ? `#${hash}` : ""));
    }
  };

  return (
    <Ham.BurgerMenuContainer $isScrolled={isScrolled}>
      <Ham.AtLogoMobile $isScrolled={isScrolled} />

			<Ham.NavButton
				onClick={toggleMenu}
				aria-expanded={menuOpen}
				aria-controls="menu"
				/>

      <Ham.CrossDiv open={menuOpen}>
        <Ham.CrossIcon onClick={() => setMenuOpen(false)}>
          <span></span>
          <span></span>
        </Ham.CrossIcon>
      </Ham.CrossDiv>

			<Ham.Menu open={menuOpen} id="menu">
				<ul>
					<li>
						<Ham.BurgerMenuLinks onClick={() => closeMenu("/")} to="/">
							Hem
						</Ham.BurgerMenuLinks>
					</li>
					<li>
						<Ham.BurgerMenuLinks
							onClick={() => closeMenu("/", "tjanster")}
							to="/#tjanster">
							Tjänster
						</Ham.BurgerMenuLinks>
					</li>
					<li>
						<Ham.BurgerMenuLinks
							onClick={() => closeMenu("/om-oss")}
							to="/om-oss">
							Om oss
						</Ham.BurgerMenuLinks>
					</li>
					<li>
					<Ham.MenuContactButton 
					to="/om-oss/#kontakt" closeMenu={() => setMenuOpen(false)} />
					</li>
				</ul>
			</Ham.Menu>
		</Ham.BurgerMenuContainer>
	)
}
